export default function () {

  return function nrgColor(val = '') {
    if (val > 0.0 && val <= 0.5) {
      return '#64d268';
    } else if (val > 0.5 && val <= 1.0) {
      return '#439029';
    } else if (val > 1.0 && val <= 1.5) {
      return '#e6ec75';
    } else if (val > 1.5 && val <= 2.0) {
      return '#ecd32f';
    } else if (val > 2.0 && val <= 5.0) {
      return '#ebb134';
    } else if (val > 5.0 && val <= 10.0) {
      return '#ec7538';
    } else if (val > 10.0) {
      return '#ec4630';
    }
    return '#000000';
  };
}



// WEBPACK FOOTER //
// ./src/filters/nrgColor.js